__turbopack_context__.v({
  "YouTubeVideoList__Button--Desktop": "z10E1G_YouTubeVideoList__Button--Desktop",
  "YouTubeVideoList__Button--Mobile": "z10E1G_YouTubeVideoList__Button--Mobile",
  "YouTubeVideoList__Container": "z10E1G_YouTubeVideoList__Container",
  "YouTubeVideoList__Content": "z10E1G_YouTubeVideoList__Content",
  "YouTubeVideoList__Item": "z10E1G_YouTubeVideoList__Item",
  "YouTubeVideoList__Item--1": "z10E1G_YouTubeVideoList__Item--1",
  "YouTubeVideoList__Item--2": "z10E1G_YouTubeVideoList__Item--2",
  "YouTubeVideoList__Item--3": "z10E1G_YouTubeVideoList__Item--3",
  "YouTubeVideoList__List": "z10E1G_YouTubeVideoList__List",
  "YouTubeVideoList__Preamble": "z10E1G_YouTubeVideoList__Preamble",
  "YouTubeVideoList__Row": "z10E1G_YouTubeVideoList__Row",
  "YouTubeVideoList__Title": "z10E1G_YouTubeVideoList__Title",
});
